import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css, CSSResult } from 'lit'

export const style: CSSResult = css`
    :host {
        display: contents;
    }

    cse-selectable {
        flex-grow: 1;
    }

    .gift {
      display: flex;
      gap: ${csSpacing.spacing06};
    }

    .footer {
        align-items: stretch;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        gap: ${csSpacing.spacing06};
        text-align: center;
    }
`
